<div>

  <div class="back" (click)="cancel()">
    <div class="fa fa-chevron-left"></div>
    <div>{{ 'bikeshop.modal.shedule_service.button.back' | translate }}</div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="sub-header">
        {{
        appConfig.getCustomLabelForMessageTag(messageTemplate.eventTag, (messageTemplate.eventTag + '_title' | translate :
          {
            ServiceFollowUpReminderMonths:
            partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService: partner.ReminderHoursBeforeService,
            WaitingDelayHours: partner.WaitingDelayHours, OtherServiceFollowUpReminderMonths:
            partner.OtherServiceFollowUpReminderMonths,
            PostServiceFollowUpDays: partner.PostServiceFollowUpDays
          }), false)
        }}
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 margin-bottom-16">
      <div class="label bold">
        {{
        appConfig.getCustomLabelForMessageTag(messageTemplate.eventTag, (messageTemplate.eventTag + '_description' |
          translate : {
          ServiceFollowUpReminderMonths:
          partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService: partner.ReminderHoursBeforeService,
          WaitingDelayHours: partner.WaitingDelayHours, OtherServiceFollowUpReminderMonths:
          partner.OtherServiceFollowUpReminderMonths,
          PostServiceFollowUpDays: partner.PostServiceFollowUpDays
        }), true)
        }}
      </div>
    </div>
  </div>

  <div class="row margin-top-8">
    <div class="col-md-6 col-lg-3 label flex">{{'bikeshop.message_templates.disabled_messaging' | translate}}:</div>
    <div class="col-md-1 col-lg-1">
      <p-inputSwitch [(ngModel)]="messageTemplate.disableMessaging"
                     (onChange)="disableMessaging()"></p-inputSwitch>
    </div>
    <div class="col-md-5 col-lg-8 label flex">
      <small>{{'bikeshop.message_templates.disabled_messaging_desc' | translate}}</small></div>
  </div>

  <div class="row margin-top-16">
    <div class="col-md-6 col-lg-3 label">{{'bikeshop.message_templates.short_message_active' | translate}}:</div>
    <div class="col-md-6 col-lg-9">
      <p-inputSwitch [(ngModel)]="messageTemplate.shortMessageTemplateActive"
                     [disabled]="messageTemplate.disableMessaging"></p-inputSwitch>
    </div>
  </div>
  <div class="row margin-top-16">
    <div class="col-md-12 col-lg-3 label">{{ 'bikeshop.message_templates.short_message_template' | translate}}:
    </div>
    <div class="col-md-12 col-lg-9">
      <input type="text" pInputText maxlength="160" [(ngModel)]="messageTemplate.shortMessageTemplate"
             [disabled]="messageTemplate.disableMessaging"/>
      <div class="char-limit">
        {{
        160 - (messageTemplate.ShortMessage_Template !== null &&
        messageTemplate.ShortMessage_Template !== undefined ? messageTemplate.ShortMessage_Template.length : 0) - 30 - partner.Name.length
        }} Left
      </div>
      <!--<small class="char-limit">
        {{
        partner.Name + ': ' + messageTemplate.ShortMessage_Template + ' https://tinyurl.com/xxxxxxxx'
        }}
      </small>-->
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 col-lg-3"></div>
    <div class="col-md-12 col-lg-9">
      <small>
        *{{
        'bikeshop.message_templates.short_message_information' | translate
        }}
      </small>
    </div>
  </div>


  <div class="row margin-top-16">
    <div class="col-md-6 col-lg-3 label">{{'bikeshop.message_templates.available_merge_tags' | translate}}:</div>
    <div class="col-md-6 col-lg-9 merge-tag-container">
      <div *ngFor="let tag of listMergeTags()">
        <div>{{tag.value}}</div>
      </div>
    </div>
  </div>

  <hr/>
  <div class="row margin-top-16">
    <div class="col-md-6 col-lg-3 label">{{'bikeshop.message_templates.active' | translate}}:</div>
    <div class="col-md-6 col-lg-9">
      <p-inputSwitch [(ngModel)]="messageTemplate.emailTemplateActive"
                     [disabled]="messageTemplate.disableMessaging"></p-inputSwitch>
    </div>
  </div>
  <div class="row margin-top-16">
    <div class="col-md-12 col-lg-3 label">{{ 'bikeshop.message_templates.email_subject' | translate}}:</div>
    <div class="col-md-12 col-lg-9">
      <input type="text" pInputText maxlength="100" [(ngModel)]="messageTemplate.emailTemplateSubject"
             [disabled]="messageTemplate.disableMessaging"/>
    </div>
  </div>
  <div class="row margin-top-16">
    <div class="col-md-12">
      <email-editor (loaded)="editorLoaded()" [appearance]="appearance" [options]="options"
                    [minHeight]="(screenHeight - 530 < 530 ? 530 : screenHeight - 530)+'px'"></email-editor>
    </div>
  </div>
  <div style="margin-top: -50px;margin-left: 8px;" *ngIf="classicTemplate && !saving">
    <button pButton class="accent" (click)="resetTemplate()"
            label="{{'bikeshop.message_templates.use_new_template_builder' | translate}}"
            [disabled]="saving"></button>
  </div>
  <div class="row margin-top-16" *ngIf="filteredMessageTemplates.length > 0">
    <div class="col-md-6 col-lg-3 label">{{'bikeshop.message_templates.import_template_from' | translate}}:</div>
    <div class="col-md-6 col-lg-3">
      <p-dropdown [options]="filteredMessageTemplates" [(ngModel)]="templateImport"
                  placeholder="Select a template to import"></p-dropdown>
    </div>
    <div class="col-md-6 col-lg-3">
      <button pButton class="p-button-raised alternate" label="{{'general.import' | translate}}"
              [disabled]="templateImport === null || templateImport.length===0" (click)="importDesign()"></button>
    </div>
  </div>

  <div class="row margin-top-32 margin-bottom-32">
    <div class="col-md-3">
      <button pButton class="full-width alternate" (click)="cancel()" label="{{'general.cancel' | translate}}"
              [disabled]="saving"></button>
    </div>
    <div class="col-md-6"></div>
    <div class="col-md-3">
      <button pButton class="full-width" (click)="saveTemplate()"
              label="{{'bikeshop.message_templates.save_template' | translate}}" [disabled]="saving"></button>
    </div>
  </div>
</div>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
<p-confirmDialog key="add_edit_message_templates"></p-confirmDialog>
